/**
 * Created by matheusmorett on 9/18/17.
 */
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
// import 'react-dates/initialize'
import { SingleDatePicker } from 'react-dates';
import moment from 'moment';
import 'moment/locale/pt-br';
import Modal from 'react-modal';
import { HORIZONTAL_ORIENTATION, VERTICAL_ORIENTATION } from 'react-dates/constants';
import 'react-dates/lib/css/_datepicker.css';
import Checkbox from 'components/Checkbox';
import CustomModal from 'components/Modal';
import Alert from 'components/Alert';
import Ribbon from 'components/Ribbon';
import ShareButtons from 'components/ShareButtons';
import Button from 'components/Button';
import PageLoader from 'components/PageLoader';
import PublicReserves from './../PublicReserves';
import Package from './../Package';

import GTM from 'utils/GTM';
import Utils from "utils/Utils"

import { ADVENTURE, EVENT, MODAL_STYLES } from 'utils/Consts';

import "./Checkout.scss";
import CalendarView from '../CalendarView';
import CardView from '../CardView';
import RequestForm from '../RequestForm'
import ReserveForm from '../ReserveForm';
import RequestSuccess from '../RequestSuccess';
import Metrics from '../../../../utils/Metrics';

@inject('RequestStore', 'AdventuresStore', 'AuthStore', 'ApplicationStore', 'PaymentStore', 'CheckoutStore')
@observer
class Checkout extends Component {

  static defaultProps = {
    goToPayment: () => {
    },
    goToIGo: () => {
    }
  };

  constructor(props) {
    super(props);

    const { AuthStore } = this.props;

    this.state = {
      focused: false,
      modalReserve: false,
      modalMoreDates: false,
      modalContact: false,
      loadedMonths: [],
      formError: {
        status: false,
        message: ""
      },
      fields: [],
      email: (!!AuthStore.isLogged) ? AuthStore.authUser.email : undefined,
      emailRight: (!!AuthStore.isLogged) ? true : false,
      message: "Olá. Gostaria de mais informações sobre as reservas.",
      packageDropdownIsOpen: false,
      package_dropdown_selection: {
        name: 'Selecione',
        value: 0
      },
      hour_dropdown_is_open: false,
      mobileDateModal: false,
      showingTopSettled: false,
      months: {},
      firstLoadCalendar: true,
      showPhone: false,
      showMail: false
    };

    this.closeModal = this.closeModal.bind(this);
    this.closeAlert = this.closeAlert.bind(this);
    this.handleSeeMoreDates = this.handleSeeMoreDates.bind(this);
    this.handleCloseModalSeeMoreDates = this.handleCloseModalSeeMoreDates.bind(this);
    this.handleGoToPayment = this.handleGoToPayment.bind(this);
    this.handleGoToIGo = this.handleGoToIGo.bind(this);
    this.handleModalContact = this.handleModalContact.bind(this);
    this.handleSubmitContact = this.handleSubmitContact.bind(this);
    this.isDateDisabled = this.isDateDisabled.bind(this);
    this.loadSchedule = this.loadSchedule.bind(this);
    this.handleSetDate = this.handleSetDate.bind(this);
    this.handleSetHour = this.handleSetHour.bind(this);
    this.submitRequest = this.submitRequest.bind(this);
    this.showMail = this.showMail.bind(this);
    this.showPhone = this.showPhone.bind(this);
    this.handleFieldsChange = this.handleFieldsChange.bind(this);
  }

  componentWillMount() {
    const { AdventuresStore, RequestStore } = this.props;

    RequestStore.setAdventure(AdventuresStore.Adventure);

    if (!RequestStore.getSelectedPackage) {
      RequestStore.selectFirstPackage();
    }

    //RequestStore.makeEventOperatings()

    if (RequestStore.adventure.online_scheduling) {
      RequestStore.getCustomFields(true).then(fields => this.setState({ fields }));
    }

    this.loadSchedule(AdventuresStore.Adventure.nextDate ? moment(AdventuresStore.Adventure.nextDate).toDate() : new Date())
    this.setState({ calendarToOpenDate: AdventuresStore.Adventure.nextDate ? moment(AdventuresStore.Adventure.nextDate).toDate() : new Date() })
  }

  componentDidMount() {
    if (!this.props.relative)
      window.addEventListener('scroll', this.handleScroll.bind(this));
  }

  componentWillUnmount() {
    const { RequestStore } = this.props;
    RequestStore.removeDate();
    RequestStore.removeHour();
    RequestStore.resetEvent();
    Utils.addBodyScroll();
    if (!this.props.relative)
      window.removeEventListener('scroll', this.handleScroll.bind(this));
  }

  loadSchedule(date) {
    const { RequestStore } = this.props
    return RequestStore.getAvaiableHoursOfAdventureByDate(moment(date).toDate())
      .then(() => {
        Metrics.triggerLoadSchedule({ fk_company: RequestStore.adventure.fkCompany, fk_adventures: RequestStore.adventure.pkAdventure })
        if (Object.keys(RequestStore.schedule[RequestStore.adventure.pkAdventure]).length > 0 && this.state.firstLoadCalendar) {
          this.setState({
            firstLoadCalendar: false
          })
        }
        const nextMonth = moment(date).add('1', 'month').toDate();
        RequestStore.getAvaiableHoursOfAdventureByDate(nextMonth).then(() => {
          if (Object.keys(RequestStore.schedule[RequestStore.adventure.pkAdventure]).length > 0 && this.state.firstLoadCalendar) {
            this.setState({
              firstLoadCalendar: false
            })
          }
          const newNextMonth = moment(nextMonth).add('1', 'month').toDate();
          RequestStore.getAvaiableHoursOfAdventureByDate(newNextMonth).then(() => {
            if (this.state.firstLoadCalendar) {
              this.setState({
                firstLoadCalendar: false
              })
            }
          })
        })

        if (!RequestStore.hasAvailableDates && !!RequestStore.adventure.voucher_enabled) {
          RequestStore.setVoucherSelected(true)
        } else {
          RequestStore.setVoucherSelected(false)
        }
      })
  }

  isDateDisabled(date) {
    const { RequestStore, AdventuresStore } = this.props;
    const adventureSchedule = RequestStore.schedule[AdventuresStore.Adventure.pkAdventure]
    const monthLoaded = RequestStore.loadedMonths.includes(moment(date).format('YYYY-MM'))

    const adventureScheduleDate = !!adventureSchedule && adventureSchedule[moment(date).format('YYYY-MM-DD')]
    const isDateAlreadyPassed = moment(date).isBefore(new Date()) && !moment(date).isSame(new Date(), 'date')

    return isDateAlreadyPassed || ((!adventureSchedule || !adventureScheduleDate || !adventureScheduleDate.availableHours.length) && monthLoaded)
  }

  getParamsToCheckout() {
    const { RequestStore } = this.props;
    const { pk_schedule_rule } = RequestStore.hour
    const request = RequestStore.getCurrentRequest();
    const data = !!request && request.pk_request ? { pk_request: request.pk_request } : { pk_schedule_rule }

    const params = {
      date: RequestStore.date,
      hour: RequestStore.hour,
      voucherSelected: RequestStore.voucherSelected,
      isRequest: !!RequestStore.isPaymentForRequest,
      type: RequestStore.activeButton,
      url_name: RequestStore.adventure.urlName,
      pkRuleTime: RequestStore.pkRuleTime,
      pkPackage: RequestStore.getSelectedPackage.pkPackage,
      fkAdventure: RequestStore.getSelectedPackage.fkAdventure,
      requestPackagesParams: data,
      packages: RequestStore.avaiablePackages.filter(p => p.quantity)
    };

    return params;
  }

  handleGoToIGo(r) {
    const { RequestStore } = this.props;
    const hour = {
      start: r.date.split(' ')[1],
      pk_schedule_rule: r.fk_schedule_rule
    };
    RequestStore.setDate(r.date)
    RequestStore.setHour(hour);
    const params = this.getParamsToCheckout();
    params.token = r.token;
    this.props.goToIGo(r.token, params);
  }

  handleGoToPayment(date = null) {
    const { RequestStore } = this.props;

    this.setState({
      modalReserve: false,
      modalMoreDates: false
    });

    // GTM.dispatch('reservaPorAdrena');
    GTM.dispatch(GTM.EVENT_SELECT_PACKAGES)
    this.props.goToPayment(this.getParamsToCheckout(date));
  }

  submitRequest(payload) {
    const { RequestStore, ApplicationStore, AuthStore } = this.props;
    const params = this.getParamsToCheckout()
    localStorage.setItem('requestParams', JSON.stringify(params));
    // GTM.dispatch('agendamentoPorAdrena');
    RequestStore.submitRequest({
      ...payload,
      fields: this.state.fields,
      pkAdventure: RequestStore.adventure.pkAdventure,
      date: `${moment(RequestStore.date).format('YYYY-MM-DD')} ${RequestStore.hour.start}:00`,
      pk_schedule_rule: RequestStore.hour.pk_schedule_rule
    }).then(() => {
      GTM.dispatch(GTM.EVENT_CREATE_REQUEST);
      Metrics.triggerReserveFilled({ fk_company: RequestStore.adventure.fkCompany, fk_adventure: RequestStore.adventure.pkAdventure });
      Metrics.triggerReservationCompleted({ fk_company: RequestStore.adventure.fkCompany, fk_adventure: RequestStore.adventure.pkAdventure });
    }
    );

  }

  handleReserve() {

    const { RequestStore, AdventuresStore } = this.props;

    if (window.innerWidth > 479 || this.state.mobileDateModal) {
      if (!RequestStore.isDateSelected) {
        window.scrollTo({
          'behavior': 'smooth',
          'left': 0,
          'top': document.getElementById("AdventureBanner").offsetHeight
        });
        this.setState({
          formError: {
            status: true,
            message: "Você deve selecionar uma data para continuar."
          }
        })
      } else if (!RequestStore.isHourSelected) {
        this.setState({
          formError: {
            status: true,
            message: "Você deve selecionar um horário para continuar."
          }
        });
      } else {
        //GTM.dispatch('quero-reservar');
        this.handleGoToPayment();
      }
    } else {
      this.setState({
        mobileDateModal: true
      })
    }

  }

  closeModal() {
    this.setState({
      modalReserve: false,
      modalContact: false
    });
    Utils.addBodyScroll();
  }

  closeAlert() {
    this.setState({
      formError: {}
    });
  }

  handleFieldsChange(value, i) {
    const field = this.state.fields[i]
    field.value = value
    const fields = this.state.fields
    fields[i] = field
    this.setState({ fields })
  }

  handleScroll() {
    //elements refs
    const stickyElement = this.stickyElement;
    const stickElementParent = document.getElementById('grid-payment');
    const bannerSection = document.getElementById('AdventureBanner');

    if (stickyElement && stickElementParent && bannerSection) {
      //useful vars
      const isMobile = window.innerWidth < 768
      const topToStickyElementGo = bannerSection.offsetTop + bannerSection.clientHeight;
      const bottomToStickyElementGo = stickElementParent.getBoundingClientRect().y + stickElementParent.getBoundingClientRect().height

      if (!stickyElement) return;

      if (window.pageYOffset >= topToStickyElementGo - 130 - 15 && !isMobile) {
        if (bottomToStickyElementGo <= stickyElement.offsetHeight) {
          stickyElement.style.position = 'absolute';
          stickyElement.style.top = (stickElementParent.clientHeight - stickyElement.clientHeight) + 15 + 'px';
        } else {
          stickyElement.style.position = 'fixed';
          stickyElement.style.top = 0;
          stickyElement.style.marginTop = '145px';
        }
      } else {
        stickyElement.style.marginTop = 0;
        stickyElement.style.position = 'relative';
      }

      if (isMobile) {
        if (window.pageYOffset >= (topToStickyElementGo + 110)) {
          this.checkoutContainer.classList.add('showing');
        } else {
          this.checkoutContainer.classList.remove('showing');
        }
      }
    }

    if (window.pageYOffset > 300) {
      this.setState({
        showingTopSettled: true
      });
    } else {
      this.setState({
        showingTopSettled: false
      });
    }

    /**/
  }

  handleOpenCalendar() {
    //Verificar aqui se a data foi preenchida

    this.setState({
      focused: !this.state.focused,
    })

    if (!this.state.focused && window.matchMedia('(max-width: 768px)').matches) {
      Utils.removeBodyScroll();
      return true;
    }
    Utils.addBodyScroll();

  }

  handleSeeMoreDates() {
    const { ApplicationStore } = this.props;
    ApplicationStore.unsetModalNotClosable();
    Utils.removeBodyScroll();

    this.setState({
      modalMoreDates: true
    });
  }

  handleCloseModalSeeMoreDates() {
    this.setState({
      modalMoreDates: false
    });
    Utils.addBodyScroll();
  }

  handleSetDate(date) {
    const { RequestStore } = this.props;
    const monthLoaded = RequestStore.loadedMonths.includes(moment(date).format('YYYY-MM'))
    if (!monthLoaded) {
      this.loadSchedule(date)
      RequestStore.setDate(null);
      this.setState({ calendarToOpenDate: date })
    } else {
      RequestStore.setDate(date);
      this.setState({ calendarToOpenDate: undefined })
    }
    RequestStore.removeHour();
    // GTM.dispatch('selecaoData');
    this.closeAlert();
  }

  handleSetHour(hour) {
    const { RequestStore } = this.props;
    RequestStore.handleSetHour(hour);
    //GTM.dispatch('selecaoHora');
    GTM.dispatch(GTM.EVENT_SELECT_HOUR, {
      adventure: RequestStore.adventure.title,
      date: moment(RequestStore.date).format("HH:mm DD/MM/YYYY")
    })
    Metrics.triggerHourSelected({ fk_company: RequestStore.adventure.fkCompany, fk_adventure: RequestStore.adventure.pkAdventure })
    this.closeAlert();
  }

  handleVerifyIfDateIsAvailable(date) {
    const { RequestStore } = this.props;
    return RequestStore.handleVerifyIfDateIsAvailable(date);
  }

  handleModalContact() {
    this.setState({
      modalContact: true
    });
  }

  handleInputChange(e) {
    const name = e.target.name;
    const value = e.target.value;

    if (name === "email") {
      if (Utils.validateEmail(value) === false) {
        this.setState({
          emailRight: false
        });
      } else {
        this.setState({
          emailRight: true
        });
      }
    }

    this.setState({
      [name]: value
    });
    this.checkFields(name);
  }


  handleInputBlur(e) {
    const name = e.target.name;
    this.checkFields(name);
  }

  checkFields(name) {
    if (this.state[name] === "" || this.state[name] === false || this.state[name] === undefined) {
      this.setState({
        [name + "Error"]: true
      });
    } else {
      this.setState({
        [name + "Error"]: false
      });
    }
  }

  handleSubmitContact(e) {

    e.preventDefault();

    const { AdventuresStore } = this.props;

    if (this.state.email !== "" && this.state.emailRight === true && this.state.message !== "") {

      const params = {
        email: this.state.email,
        message: this.state.message,
        pkAdventure: AdventuresStore.Adventure.pkAdventure
      };

      AdventuresStore.contactAdventure(params);
      this.setState({
        formError: {
          status: false,
          message: "Mensagem enviada com sucesso"
        },
        message: ""
      });

    } else {
      this.checkFields("message");
      this.checkFields("email");
    }
  }

  handleSetEventDateTime(date, hour) {
    const { RequestStore } = this.props;

    RequestStore.setDate(date);
    RequestStore.setHour(hour);
  }

  showPhone() {
    this.setState({ showPhone: true })
  }

  showMail() {
    this.setState({ showMail: true })
  }

  getCardViewRules() {
    const { RequestStore, AdventuresStore } = this.props;

    return Object.keys(RequestStore.schedule[AdventuresStore.Adventure.pkAdventure]).map(day => RequestStore.schedule[AdventuresStore.Adventure.pkAdventure][day])
  }

  render() {
    const { modalMoreDates, focused, showingTopSettled } = this.state;
    const { RequestStore, ApplicationStore, PaymentStore, AdventuresStore, CheckoutStore, token } = this.props;
    const Adventure = RequestStore.adventure;
    const smallDevice = window.matchMedia('(max-width: 768px)').matches;
    const orientation = smallDevice ? VERTICAL_ORIENTATION : HORIZONTAL_ORIENTATION;
    const request = RequestStore.getCurrentRequest();
    const chooseDateTimeLater = !Adventure.online_scheduling && Adventure.voucher_enabled && !RequestStore.request ? true : false;
    let viewMode = '';
    if (Adventure !== undefined) {
      let contact_mail = '', contact_phone = '';

      if (Adventure.company_phone) {
        contact_phone = !this.state.showPhone ?
          <p>{Adventure.company_phone.substring(0, 7)}... <span className="action action-phone"
            onClick={this.showPhone}>ver número</span></p> :
          <p>{Adventure.company_phone ? Adventure.company_phone : ''}</p>
      }

      if (Adventure.company_mail) {
        contact_mail = !this.state.showMail ?
          <p>{Adventure.company_mail.substring(0, 7)}... <span className="action action-mail" onClick={this.showMail}>ver email</span>
          </p> : <p>{Adventure.company_mail ? Adventure.company_mail : ''}</p>
      }

      const noResults = (<div>
        <h2>Pronto(a) para sua próxima aventura?</h2>
        <p style={{ fontSize: '18px', color: '#999' }}>
          Essa aventura não possui agendamento online. Entre em contato diretamente com o realizador e faça sua reserva!
        </p>
        {contact_phone}
        {contact_mail}
      </div>)

      const voucherOnly = (<div>
        <h2>Pronto(a) para sua próxima?</h2>
        <p style={{ fontSize: '18px', color: '#999' }}>
          Compre seu voucher agora mesmo!
        </p>
      </div>)

      var timeLimitBlockReached = false;
      if (RequestStore.request) {
        const today = moment().utc()
        const requestDatetime = moment(RequestStore.date, 'MM-DD-YYYY hh:mm');
        const hoursBetweenTodayAndEvent = moment.duration(requestDatetime.diff(today));

        timeLimitBlockReached = hoursBetweenTodayAndEvent.asHours() < RequestStore.request.adventure.block_participation_hours_before;
      }

      if (RequestStore.request && !token) {
        viewMode = (
          <div>
            <RequestSuccess
              request={RequestStore.request}
              success_message={Adventure.request_success_message}
              onContinue={(short_url) => {
                if (this.props.relative) {
                  window.open(short_url, '_blank');
                } else if (ApplicationStore.minimalTemplate) {
                  ApplicationStore.history.push('/site/' + Adventure.company_url + '/' + Adventure.urlName + '/' + RequestStore.request.token)
                } else {
                  ApplicationStore.history.push(Adventure.urn + '/' + RequestStore.request.token)
                }
              }}
              onShare={(short_url) => {
                // const shareLink = ApplicationStore.minimalTemplate ? window.location.origin + '/site/' + Adventure.company_url + '/' + Adventure.urlName + '/' + token : Adventure.urn + '/' + token
                Utils.shareLink(short_url)
                GTM.dispatch(GTM.EVENT_SHARE_LINK)
              }} />
          </div>
        )
      } else if ((!RequestStore.request && token) || ((RequestStore.request && token) && timeLimitBlockReached)) {
        viewMode = (<div>
          {RequestStore.request &&
            <div className="adventure-date">
              <div className="date">
                <span className="icon icon-calendar-full" />
                {moment(RequestStore.request.date).format("DD/MM/YY")}
              </div>
              <div className="hour">
                <span className="icon icon-clock3" />
                {moment(RequestStore.request.date).format("HH:mm")}
              </div>
            </div>
          }
          <h2>Reservas online encerradas</h2>
          <p style={{ fontSize: '18px', color: '#999' }}>
            As inscrições para este evento já foram encerradas! <br />
            Confira outros horários disponíveis ou entre em contato com a {Adventure.company} <br />
            <a className="action" href={Adventure.urn}>Conferir horários</a> <br />
            {contact_phone} <br />
            {contact_mail} <br />
          </p>
        </div>)
      } else {
        viewMode = (
          <div>
            <PageLoader loading={this.state.firstLoadCalendar}>
              {RequestStore.request ?
                <div className="adventure-date">
                  <div className="date">
                    <span className="icon icon-calendar-full" />
                    {moment(RequestStore.request.date).format("DD/MM/YY")}
                  </div>
                  <div className="hour">
                    <span className="icon icon-clock3" />
                    {moment(RequestStore.request.date).format("HH:mm")}
                  </div>
                </div>
                :
                <>
                  <div className="header-title"><h4>Consulte horários</h4></div>
                  <div className="Grid-cell pickers">
                    {(RequestStore.adventureType === ADVENTURE) ?
                      <CalendarView
                        hasAvailableDates={RequestStore.hasAvailableDates}
                        noResults={(!!RequestStore.hasAvailableDates || !RequestStore.adventure.voucher_enabled) ? noResults : voucherOnly}
                        // <div className="no-available-dates"> Sem horário disponível </div>
                        firstLoadCalendar={this.state.firstLoadCalendar}
                        isLoadingDates={RequestStore.loadingGetSchedule}
                        calendarToOpenDate={this.state.calendarToOpenDate}
                        date={!RequestStore.voucherSelected ? RequestStore.date : ''}
                        hour={!RequestStore.voucherSelected ? RequestStore.hour : ''}
                        handleSetDate={this.handleSetDate}
                        getFirstOperatingDate={moment(Adventure.nextDate)}
                        focused={focused}
                        handleOpenCalendar={this.handleOpenCalendar.bind(this)}
                        loadSchedule={this.loadSchedule}
                        isDateDisabled={this.isDateDisabled}
                        orientation={orientation}
                        smallDevice={smallDevice}
                        availableHours={RequestStore.date && RequestStore.schedule[AdventuresStore.Adventure.pkAdventure][moment(RequestStore.date).format("YYYY-MM-DD")] ? RequestStore.schedule[AdventuresStore.Adventure.pkAdventure][moment(RequestStore.date).format("YYYY-MM-DD")].availableHours : []}
                        handleSetHour={this.handleSetHour}
                        isVoucherSelected={RequestStore.voucherSelected}
                      />
                      :
                      <CardView
                        getEventOperatings={this.getCardViewRules.bind(this)}
                        setDate={(date) => RequestStore.setDate(date)}
                        setHour={this.handleSetHour}
                        date={!RequestStore.voucherSelected ? RequestStore.date : ''}
                        hour={!RequestStore.voucherSelected ? RequestStore.hour : ""}
                        getVacanciesInDate={(startDate, hour) => RequestStore.getVacanciesInDate(startDate, hour)}
                        getIsDatePrivate={(startDate, hour) => RequestStore.getIsDatePrivate(startDate, hour)}
                        handleGetMoreEventDates={() => RequestStore.handleGetMoreEventDates()}
                        isVoucherSelected={RequestStore.voucherSelected}
                      />
                    }
                  </div>
                </>
              }
              {(!!Adventure.voucher_enabled && !RequestStore.request) &&
                <div>
                  <Checkbox
                    checked={RequestStore.voucherSelected}
                    onChange={(checked) => RequestStore.setVoucherSelected(checked)}
                    readOnly={chooseDateTimeLater}
                    text="Vou escolher data/hora depois"
                  />
                </div>
              }
              <div>
                <Alert formError={this.state.formError} closeAlert={this.closeAlert} />
              </div>
              {Adventure.only_public || token || RequestStore.voucherSelected || RequestStore.isPaymentForRequest || (!!request && request.type == 1) ?
                <ReserveForm
                  isDateSelected={RequestStore.isDateSelected}
                  isHourSelected={RequestStore.isHourSelected}
                  isVoucherSelected={RequestStore.voucherSelected}
                  isForRequest={RequestStore.isPaymentForRequest}
                  packages={RequestStore.avaiablePackages}
                  packagesCount={RequestStore.packagesCount}
                  cancel_rules={Adventure.cancel_rules}
                  request={RequestStore.request}
                  loadingContinue={CheckoutStore.registeringCart}
                  isMobile={smallDevice && !this.props.relative}
                  isModal={this.state.mobileDateModal}
                  onContinue={!smallDevice || this.props.relative ? () => this.handleGoToPayment() : () => this.setState({ mobileDateModal: true })}
                  onModalContinue={() => this.handleGoToPayment()}
                  loadingPackages={RequestStore.loadingPackages}
                  handleRemovePackage={(pkPackage) => RequestStore.removePackage(pkPackage)}
                  handleAddPackage={(pkPackage) => RequestStore.addPackage(pkPackage)}
                  canAddPackage={(pkPackage) => RequestStore.canAddPackage(pkPackage)}
                  canRemovePackage={RequestStore.canRemovePackage}
                  vacancies={RequestStore.getAvailableVacancies()}
                  noLinks={this.props.noLinks || ApplicationStore.minimalTemplate}
                  privacyTerm={Adventure.privacyTerm}
                />
                :
                <RequestForm
                  isDateSelected={RequestStore.isDateSelected}
                  isHourSelected={RequestStore.isHourSelected}
                  request_observation_enabled={Adventure.request_observation_enabled}
                  date={RequestStore.date}
                  hour={RequestStore.hour}
                  fields={this.state.fields}
                  onChange={(v, i) => this.handleFieldsChange(v, i)}
                  cancel_rules={Adventure.cancel_rules}
                  hours_before={Adventure.block_request_hours_before}
                  terms={Adventure.terms}
                  showTerms={Adventure.terms_on_request}
                  privacyChecked={CheckoutStore.privacyChecked}
                  onPrivacyToggle={() => CheckoutStore.togglePrivacyChecked()}
                  privacyTerm={Adventure.privacyTerm}
                  submitRequest={(payload) => this.submitRequest(payload)}
                  requestLoading={RequestStore.loading}
                  noLinks={this.props.noLinks || ApplicationStore.minimalTemplate}
                />
              }
            </PageLoader>
          </div>
        )
      }

      return (
        <div className={`grid-payment-sticky ${this.props.relative ? 'relative' : ''}`} ref={el => this.stickyElement = el}>
          <div id="Checkout" className={"Checkout " + ((Adventure.haveSeen > 0 && !smallDevice) && "with-ribbon")}
            ref={el => this.checkout = el}>
            {((smallDevice || this.props.relative) &&
              <CustomModal
                open={this.state.mobileDateModal}
                showBackButton
                adventureName={RequestStore.adventure && RequestStore.adventure.title}
                onBack={() => this.setState({ mobileDateModal: false })}>
                {/* <div className="container-scroll"> */}
                <div className="pickers show-on-mobile">
                  {(!!Adventure.nextDate || !!Adventure.voucher_enabled) || token ?
                    viewMode
                    :
                    noResults
                  }
                </div>
                {/* </div> */}
              </CustomModal>
            )}
            {/* Checkout infos */}
            <div className="Grid-column container">
              {((smallDevice || this.props.relative) && !token) ?
                <>
                  <div className="header-title">
                    <h4>Confira a disponibilidade</h4>
                    <p>Encontre as próximas datas e vagas disponíveis para fazer sua reserva.</p>
                  </div>
                  <Button value="VER AGENDA" type="green" size="full" onClick={() => this.setState({ mobileDateModal: true })} />
                </>
                :
                <React.Fragment>
                  {(!!Adventure.nextDate || !!Adventure.voucher_enabled) || token ?
                    viewMode
                    :
                    noResults
                  }
                </React.Fragment>
              }
              {
                !!RequestStore.getSelectedPackage ?
                  <div className={`Grid-column container container-mobile ${this.props.relative || !token ? 'd-none' : ''}`}
                    ref={el => this.checkoutContainer = el}>
                    <div className="package-mobile">
                      <Package p={RequestStore.getSelectedPackage}
                        installmentPrice={
                          PaymentStore.getMaxInstallmentPrice(
                            (!!RequestStore.getSelectedPackage.priceWithDiscount) ?
                              RequestStore.getSelectedPackage.priceWithDiscount :
                              RequestStore.getSelectedPackage.price)
                        }
                      />
                    </div>
                    <div className="Gird-cell Grid Grid--center contract contract-mobile">
                      <Button value="CONTINUAR" type="green" size="full" onClick={() => {
                        this.setState({
                          mobileDateModal: true
                        })
                      }} />
                    </div>
                  </div>
                  :
                  <div className={`Grid-column container container-mobile  ${this.props.relative ? 'd-none' : ''}`}
                    ref={el => this.checkoutContainer = el}>
                    <div className="package-mobile">
                      Quer saber mais sobre a aventura?
                    </div>
                    <div className="Gird-cell Grid Grid--center contract contract-mobile">
                      <Button value="Entre em contato" type="green" size="full" onClick={() => {
                        this.setState({
                          mobileDateModal: true
                        })
                      }} />
                    </div>
                  </div>
              }
            </div>

            {((Adventure.top3Selled && !smallDevice) &&
              <div className={"top-selled " + (showingTopSettled && "visible")}>
                <div>
                  <span className="icon icon-trophy2" />
                </div>
                <div className="description">
                  {(Adventure.topSelled) ?
                    "Esta aventura é a mais vendida em " + Adventure.city
                    :
                    "Esta aventura é uma das mais vendidas em " + Adventure.city
                  }
                </div>
              </div>
            )}
          </div>

          {/*****PUBLIC REVERVES****/}
          {!smallDevice && !this.props.noLinks && <ShareButtons title={Adventure.title} url={window.location.href} />}
        </div>
      );

    }

    return <div></div>;

  }
}

export default Checkout;